import { render, staticRenderFns } from "./List.vue?vue&type=template&id=a0cd20b4&"
import script from "./List.vue?vue&type=script&setup=true&lang=js&"
export * from "./List.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports